__turbopack_context__.v({
  "jobServiceTypesSection": "gqVqcW_jobServiceTypesSection",
  "jobServiceTypesSection__description": "gqVqcW_jobServiceTypesSection__description",
  "jobServiceTypesSection__error": "gqVqcW_jobServiceTypesSection__error",
  "jobServiceTypesSection__grid": "gqVqcW_jobServiceTypesSection__grid",
  "jobServiceTypesSection__item": "gqVqcW_jobServiceTypesSection__item",
  "jobServiceTypesSection__title": "gqVqcW_jobServiceTypesSection__title",
});
